// @flow
import { put, call, takeLatest, select, delay } from "redux-saga/effects";
import { saveCartSuccess, fetchCartError, initiateSaveCart, saveCartError } from "../actions/cart";
import { SAVE_CART, FETCH_CART, THROTTLE_SAVE_CART } from "../actions/types";
import { saveCart as saveCartAPI, fetchCart as fetchCartAPI } from '../services/cart';
import { showErrorMsg } from "../actions/snackbar";
// import { setCookie } from '../utils';
import { validateSession } from './session';
import { processCartSku } from '../utils';
import { fetchSkusSuccess } from '../actions/skus'

// type CART_ERROR_TYPE = 'QUANTITY_CHANGED' | 'EMPTY_CART' ;


// function* updateCart(action) {
//   try {
//     const cart = yield select((state) => state.cart);
//     const { payload } = action;
//     // const updatedCart = processUpdateCart(payload, cart);
//     yield put(updateCartSuccess(updatedCart));
//     yield put(clearLastTransaction());
//     yield put(updateSkuPurchareCount(updatedCart));
//   } catch (error) {
//     // yield put(fetchPodsError(error));
//   }
// }

function* saveCart(action) {
  try {
    const cart = yield select((state) => state.cart);
    yield put(initiateSaveCart());
    const cartData = yield call(validateSession, saveCartAPI, {...action.payload, cart});         
    const message = processCartForChanges(cart, cartData);
    // const message = '';
    const updatedCart = {
      ...cartData,
      message,
      savingCart: false,
      cartError: !!message,
    }
    yield put(saveCartSuccess(updatedCart));
    if (message) {
      const {skus = new Map()} = yield select((state) => state.sku);
      const { skus: skuData } = processCartSku(skus, cart);
      yield put(fetchSkusSuccess(skuData));
    }
  } catch (error) {
    yield put(saveCartError(error));
    yield put(showErrorMsg(error.message));
  }
}

function* fetchCart(action) {
  try {
    const cartData = yield call(validateSession, fetchCartAPI, action.payload);
    const updatedCart = {
      ...cartData,
      message: '',
      fetched: true,
      cartError: false,
    }
    yield put(saveCartSuccess(updatedCart));
  } catch (error) {
    yield put(fetchCartError(error));
    yield put(showErrorMsg(error.message));
  }
}

function* throttleSaveCart(action) {
  const {delay: delayTime = 300 } = action.payload;
  yield delay(delayTime);
  yield call(saveCart, action);
}

export function* watchCart(): any {
  // yield takeEvery(UPDATE_CART, updateCart);
  yield takeLatest(THROTTLE_SAVE_CART, throttleSaveCart);
  yield takeLatest(SAVE_CART, saveCart);
  yield takeLatest(FETCH_CART, fetchCart);
}

const processCartForChanges = (oldCart, newCart): string => {
  if (!oldCart || !newCart) {
    return '';
  }

  const { totalQty = 0, sku_json: skus = {}}  = newCart;
  const length = Object.values(skus).reduce((len, data) => {
    if (data && typeof data === 'object') {
      const {skus = []} = data;
      if (Array.isArray(skus)) {
        len += skus.length;
      }
    }
    return len;
  }, 0);

  const { totalQty:oldTotalQty = 0, sku_json: oldSkus = {}}  = oldCart;
  const oldLength = Object.values(oldSkus).reduce((len, data) => {
    if (data && typeof data === 'object') {
      const {skus = []} = data;
      if (Array.isArray(skus)) {
        len += skus.length;
      }
    }
    return len;
  }, 0);

  let message = '';
  if (totalQty === 0 && oldTotalQty !== 0) {
    message = 'Items selected are unavailable. Please select different products';
  } else if (length !== oldLength ) {
    const diff = oldSkus.length -  skus.length;
    message = `${diff} Items removed`;
  } else if (totalQty !== oldTotalQty) {
    message = 'Total quantity has changed due to unavailabilty';
  }
  return message;
}